<template>
  <div class="salary-settings-users">
    <SalarySettingsUsersOpus
      v-if="isSalaryIntegrationActive"
      :users="usersWithEmployments"
      :tags="tags"
      :employments="employments"
      :isSalaryIntegrationActive="isSalaryIntegrationActive"
      @setTheEditUser="setTheEditUser"
      @editEmployment="setTheEditUserEmployment">
    </SalarySettingsUsersOpus>
    <template v-if="!isSalaryIntegrationActive">
      <div class="do-table__filters">
        <div class="do-table__filters__left">
          <Tabs
            style="height: 26px"
            :tabs="theTabs"
            :selected="theSelectedTab"
            :isLarge="false"
            @select="theSelectedTab = $event">
          </Tabs>
          <DoFiltersFilter
            :title="'Grupper'"
            :tags="tags"
            :selectedTags="appliedFilters"
            :numberOfSelectedTagsToShow="6"
            :placeholder="'Vælg grupper'"
            @select="setTagFromFilter"
            @clear="clearAllTags">
          </DoFiltersFilter>
        </div>
        <div class="do-table__filters__add">
          <span>{{ selectedUsers.length }} af {{ filteredUsers.length }}</span>
          <div class="do-dropdown" :class="{'do-dropdown--open': isDropdown}" v-on-clickaway="onClickAway">
            <button class="do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled"
                    v-if="selectedUsers.length < 1"
                    content="Vælg personale først"
                    v-tippy="{
                    placement: 'left',
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
                }">
              Tilføj ansættelser <span class="icon-arrow-down5"></span>
            </button>
            <button class="do-dropdown__toggler do-bttn do-bttn--submit" v-else
                    @click="setIsDropdown">
              Tilføj ansættelser <span class="icon-arrow-down5"></span>
            </button>
            <transition name="do-dropdown">
              <div class="do-dropdown__dropdown" v-if="isDropdown">
                <ul>
                  <li v-for="employmentType in employmentsTypesForDropdown"
                      class="do-dropdown__dropdown__item"
                      :class="{'do-dropdown__dropdown__item--active': employmentType.v_isSelected}"
                      @click="selectedEmploymentsType(employmentType.v_title)">
                    <div class="do-dropdown__dropdown__item__name">
                      <span class="icon-user"></span>
                      {{ employmentType.v_title }}
                    </div>
                    <div class="icon__checkmark" v-if="employmentType.v_isSelected">
                      <span class="icon-checkmark-circle"></span>
                    </div>
                  </li>
                  <li class="do-dropdown__dropdown__item do-dropdown__dropdown__item--add"
                      @click="setIsCreateNewEmploymentTitle(true)">
                    <div class="btn-trans">
                      Opret ny stillingskategori
                    </div>
                  </li>
                </ul>
                <div class="do-dropdown__dropdown__buttons">
                  <button class="do-bttn do-bttn--submit"
                          content="Vælg personer og ansættelser først"
                          v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
                onShow: () => selectedEmployments.length < 1 || selectedUsers.length < 1
              }"
                          :class="[{'do-bttn--submit--disabled': selectedEmployments.length < 1 || selectedUsers.length < 1}, {'do-bttn--submit--loading': isSubmittingUsers}]"
                          @click="setIsAddExistingEmploymentsToUsers(true)">
                    Gem
                  </button>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <table class="do-table do-table__user-employments">
        <thead>
        <th class="do-table__toggle-all" @click="toggleAll">
          <template v-if="selectedUsers.length === 0">
            {{ $t('vue2.tagging.select_all') }}
          </template>
          <template v-else>
            {{ $t('vue2.tagging.unselect_all') }}
          </template>
        </th>
        <th>Navn</th>
        <th>Stillingskategori</th>
        </thead>
        <tbody ref="d-b">
        <tr v-for="user in filteredUsers"
            :key="user.id"
            @click="toggleUser(user)">
          <td>
            <div class="d-checkbox"
                 :class="{'d-checkbox--active': user.v_isSelected}">
            </div>
          </td>
          <td>{{ user.name }}</td>
          <td class="d-tags">
            <div class="d-tag"
                 @click.stop="setTheEditUserEmployment({user, employment})"
                 v-for="employment in user.v_employments">
              {{ employment.title }}
              <div class="do-pill do-pill--small do-pill--yellow" v-if="employment.manual_salary">Vikarløn</div>
            </div>
            <p class="italic font-small" v-if="user.v_employments.length === 0">Ingen ansættelser</p>
          </td>
          <td>
            <div class="icon__bg-circle"
                 @click.stop="setTheEditUser(user)"
                 content='Redigér ansættelser'
                 v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
              }">
              <span class="icon-wrench"></span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </template>
    <SalarySettingsUsersUser
      v-if="theEditUser"
      :user="theEditUser"
      :theEditEmployment="theEditUserEmployment"
      :school="school"
      :isSalaryIntegrationActive="isSalaryIntegrationActive"
      @close="setTheEditUser(null)">
    </SalarySettingsUsersUser>
    <SalarySettingsCreateEmploymentType
      v-if="isAddEmploymentModal"
      :selectedUsers="selectedUsers"
      :isManualSalary="isManualSalary"
      :isCreateNewEmploymentTitle="isCreateNewEmploymentTitle"
      @setIsManualSalary="setIsManualSalary"
      @save="saveForUsers"
      @close="setIsAddExistingEmploymentsToUsers(false)">
    </SalarySettingsCreateEmploymentType>
  </div>
</template>

<script>
import DoFiltersFilter from '../../DoFilters/DoFiltersFilter.vue'
import Tabs from '../../common/Tabs.vue'
import docendo from '../../../docendo'
import {mixin as clickaway} from 'vue-clickaway'
import SalarySettingsUsersUser from './SalarySettingsUsersUser.vue'
import SalarySettingsCreateEmploymentType from './SalarySettingsCreateEmploymentType.vue'
import SalarySettingsUsersOpus from './SalarySettingsUsersOpus.vue'
import SalarySettingsUsersTable from './SalarySettingsUsersOpusTable.vue'
import AppToggle from '../../common/AppToggle.vue'

export default {
  mixins: [clickaway],
  components: {
    AppToggle,
    SalarySettingsUsersTable,
    SalarySettingsUsersOpus,
    SalarySettingsCreateEmploymentType,
    Tabs,
    DoFiltersFilter,
    SalarySettingsUsersUser
  },
  props: {
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tags: [],
      appliedFilters: [],
      selectedUsers: [],
      selectedEmployments: [],
      isDropdown: false,
      theEditUser: null,
      theEditUserEmployment: null,
      isAddEmploymentModal: false,
      isCreateNewEmploymentTitle: false,
      isManualSalary: false,
      selectedOrganisations: [],
      theTabs: [
        { id: 'all', title: 'Alle' },
        { id: 'without', title: 'Uden ansættelse' }
      ],
      theSelectedTab: 'all'
    }
  },
  computed: {
    school () {
      return this.$store.state.activeSchool
    },
    isSubmittingUsers () {
      return this.$store.state.employments.isSubmittingUser
    },
    employments () {
      return this.$store.state.employments.employments
    },
    employmentsInUserIdHash () {
      return this.$store.getters.employmentsInUserIdHash
    },
    employmentsTypes () {
      return this.$store.state.employments.employmentsTypes
    },
    employmentTypesSorted () {
      return this.$store.getters.employmentTypesActive
    },
    employmentsTypesForDropdown () {
      return this.employmentTypesSorted.map(employmentType => {
        return {
          v_title: employmentType,
          v_isSelected: this.selectedEmployments.findIndex(selectedEmployment => selectedEmployment === employmentType) > -1
        }
      })
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    usersWithEmployments () {
      return this.users.map(user => {
        const employments = this.employmentsInUserIdHash[user.id] ? this.employmentsInUserIdHash[user.id] : []
        const employmentsSorted = employments.sort((a, b) => a.title.localeCompare(b.title))
        return {
          ...user,
          v_employments: employmentsSorted.filter(employment => !employment.deleted),
          v_oldEmployments: employmentsSorted.filter(employment => employment.deleted)
        }
      })
    },
    usersWithSelection () {
      return this.usersWithEmployments.map(user => {
        return {
          ...user,
          v_isSelected: this.selectedUsers.findIndex(selectedUser => selectedUser.id === user.id) > -1
        }
      })
    },
    filteredUsers () {
      let list = this.usersWithSelection
      if (this.appliedFilters.length > 0) {
        list = list.filter(user => user.user_tags && user.user_tags.some(tag => this.appliedFilters.includes(tag)))
      }
      if (this.theSelectedTab === 'without') {
        list = list.filter(user => !user.v_employments || user.v_employments.length === 0)
      }
      return list
    }
  },
  methods: {
    setIsManualSalary (bool) {
      this.isManualSalary = bool
    },
    setIsCreateNewEmploymentTitle (bool) {
      this.isCreateNewEmploymentTitle = bool
      if (bool) {
        this.setIsAddExistingEmploymentsToUsers(true)
      }
    },
    setIsAddExistingEmploymentsToUsers (bool) {
      this.isAddEmploymentModal = bool
      if (this.isCreateNewEmploymentTitle) {
        this.selectedEmployments = []
      }
      if (!bool) {
        this.isManualSalary = false
        this.setIsCreateNewEmploymentTitle(false)
      }
    },
    updateEmployment (employment) {
      const dbObj = {
        schoolId: employment.school_id,
        userId: employment.user_id,
        employmentId: employment.id,
        manualSalary: !employment.manual_salary,
        defaultLoenart: employment.default_loenart ? employment.default_loenart * 1 : null,
        defaultLoebenummer: employment.default_loebenummer ? employment.default_loebenummer * 1 : null
      }
      docendo.updateEmployment(dbObj.schoolId, dbObj.userId, dbObj.employmentId, dbObj.manualSalary, dbObj.defaultLoenart, dbObj.defaultLoebenummer, success => {
        this.$store.dispatch('readEmployments')
      }, failure => {
        console.log('failure!')
      })
    },
    setTheEditUserEmployment (userAndEmployment) {
      if (userAndEmployment.context === 'manual_salary') {
        this.updateEmployment(userAndEmployment.employment)
        return
      }
      this.theEditUserEmployment = userAndEmployment.employment
      this.theEditUser = userAndEmployment.user
    },
    setTheEditUser (user) {
      if (!user) {
        this.theEditUserEmployment = null
      }
      this.theEditUser = user
      this.$emit('setEditUser', user)
    },
    setIsDropdown () {
      if (!this.isDropdown) {
        this.selectedEmployments = []
      }
      this.isDropdown = !this.isDropdown
    },
    saveForUsers (newEmploymentTitle) {
      if (this.selectedUsers.length < 1) {
        return
      }
      if (newEmploymentTitle) {
        this.selectedEmployments.push(newEmploymentTitle)
      }
      if (this.selectedEmployments.length < 1) {
        return
      }

      const dbObj = {
        schoolId: this.schoolId,
        userIds: [],
        employmentTypeIds: [],
        isManualSalary: this.isManualSalary
      }

      // Tjek for allerede eksisterende employmentTypeIds
      const selectedEmploymentTypeIds = this.selectedEmployments.map(employment => employment)
      let usersWithEmployments = {}

      this.selectedUsers.forEach(user => {
        const userEmployments = user.v_employments.map(employment => employment.title)

        // For hver employmentTypeId, tjek om brugeren allerede har den
        selectedEmploymentTypeIds.forEach(employmentTypeId => {
          if (userEmployments.includes(employmentTypeId)) {
            if (usersWithEmployments[employmentTypeId]) {
              usersWithEmployments[employmentTypeId].push(user.id)
            } else {
              usersWithEmployments[employmentTypeId] = [user.id]
            }
          }
        })
      })
      // Hvis ingen af brugerne har de employmentTypeIds, fortsæt med at gemme
      if (Object.keys(usersWithEmployments).length === 0) {
        dbObj.userIds = this.selectedUsers.map(user => user.id)
        dbObj.employmentTypeIds = selectedEmploymentTypeIds
        this.$emit('changedMade')
        this.$store.dispatch('createEmployments', dbObj)
        this.reset()
      } else {
        const numberOfUpdatesToCompleted = this.selectedEmployments.length
        let numberOfUpdates = 0
        this.selectedEmployments.forEach((selectedEmployment, key) => {
          const userIdsArr = usersWithEmployments[selectedEmployment] ? usersWithEmployments[selectedEmployment] : []
          const newUserIds = this.selectedUsers
            .filter(user => !userIdsArr.includes(user.id))
            .map(user => user.id)
          if (newUserIds.length > 0) {
            const newObj = {
              schoolId: this.schoolId,
              userIds: newUserIds,
              employmentTypeIds: [selectedEmployment],
              isManualSalary: this.isManualSalary
            }
            this.$emit('changedMade')
            this.$store.dispatch('createEmployments', newObj)
            numberOfUpdates++
            if (numberOfUpdates === numberOfUpdatesToCompleted) {
              this.reset()
            }
          }
        })
      }
    },
    reset () {
      this.selectedUsers = []
      this.selectedEmployments = []
      this.isDropdown = false
    },
    selectedEmploymentsType (employmentsType) {
      const idx = this.selectedEmployments.findIndex(selectedEmployment => selectedEmployment === employmentsType)
      if (idx < 0) {
        this.selectedEmployments.push(employmentsType)
      } else {
        this.selectedEmployments.splice(idx, 1)
      }
    },
    onClickAway () {
      if (!this.isDropdown) {
        return
      }
      this.selectedEmployments = []
      this.isDropdown = false
    },
    toggleUser (user) {
      const idx = this.selectedUsers.findIndex(selectedUser => selectedUser.id === user.id)
      if (idx < 0) {
        this.selectedUsers.push(user)
      } else {
        this.selectedUsers.splice(idx, 1)
      }
    },
    toggleAll () {
      if (this.selectedUsers.length > 0) {
        this.selectedUsers = []
      } else {
        this.selectedUsers = []
        this.filteredUsers.forEach(user => this.selectedUsers.push(user))
      }
    },
    setTagFromFilter (tag) {
      this.selectedUsers = []
      this.appliedFilters.push(tag)
    },
    removeTagFromFilter (tag) {
      this.selectedUsers = []
      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1)
    },
    clearAllTags () {
      this.selectedUsers = []
      this.appliedFilters = []
    },
    readAllEmployments () {
      this.$store.dispatch('readEmploymentTypes')
      this.$store.dispatch('readEmployments')
    },
    readTags () {
      this.isLoadingTags = true
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
        this.isLoadingTags = false
      })
    },
    setTbodyMaxHeight () {
      const tbody = this.$refs['d-b']
      if (!tbody) {
        return
      }
      const tbodyTop = tbody.getBoundingClientRect().top
      const windowHeight = window.innerHeight
      const maxHeight = windowHeight - tbodyTop - 20 // Adjust 20px as needed

      tbody.style.maxHeight = `${maxHeight}px`
    }
  },
  mounted () {
    this.readTags()
    this.readAllEmployments()
    this.setTbodyMaxHeight()
    window.addEventListener('resize', this.setTbodyMaxHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setTbodyMaxHeight)
  }
}
</script>

<style scoped>
@import "../../../../src/assets/css/variables.css";

.do-table__filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  border-bottom: 0;
  padding: 8px;
  border-radius: 4px 4px 0 0;
}

.do-table__filters__left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-table__filters__add {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.do-table__filters__add span {
  font-style: italic;
  font-size: 11px;
}

.do-dropdown {
  position: relative;
}

.do-dropdown .do-dropdown__toggler {
  width: 200px;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  height: 34px;
  transition: transform .25s;
}

.do-dropdown .do-dropdown__toggler:active {
  transform: scale(0.98);
}

.do-dropdown__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% + 0.5rem);
  right: 0;
  width: 300px;
  background-color: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0;
  min-width: 100px;
  user-select: none;
  border: 1px solid #6772e5;
  border-radius: 4px
}

.do-dropdown__dropdown ul {
  max-height: 70vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.do-dropdown__dropdown li {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.do-dropdown__dropdown ul li:first-child {
  border-radius: 4px 4px 0 0;
}

.do-dropdown__dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  min-height: 42px;
}

.do-dropdown__dropdown li:hover {
  background-color: #f6f9fc;
}

.do-dropdown__dropdown__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--border-color);
}

.do-dropdown__dropdown__item--active {
  background: #ccc;
  color: var(--primary);
  background-color: #f6f9fc;
}

.do-dropdown__dropdown__item--add {
  border-top: 1px solid var(--border-color);
  padding: 1rem;
}

.do-dropdown__dropdown__item .btn-trans {
  font-weight: normal;
  width: 100%;
  font-size: 11px;
  transition: transform 0.25s;
}

.do-dropdown__dropdown__item .btn-trans:active {
  transform: scale(0.98);
}

.italic.font-small {
  color: #8898aa;
}

.do-dropdown__dropdown__item__actions {
  display: flex;
  align-items: center;
}

.do-dropdown__dropdown__item__actions span {
  font-style: normal;
}

/* Enter og leave-aktive styrer selve overgangen */
.do-dropdown-enter-active, .do-dropdown-leave-active {
  transition: transform 0.15s ease, opacity 0.15s ease;
}

/* Starttilstand for enter (dropdown vises) */
.do-dropdown-enter {
  opacity: 0;
  transform: scale(0.98); /* Lille skaleringsfald i starten */
}

/* Sluttilstand for enter */
.do-dropdown-enter-to {
  opacity: 1;
  transform: scale(1); /* Tilbage til normal størrelse */
}

/* Starttilstand for leave (dropdown skjules) */
.do-dropdown-leave-to {
  opacity: 0;
  transform: scale(0.98); /* Samme lille skaleringsfald ved lukning */
}

.do-dropdown__dropdown__item__name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.do-dropdown__dropdown__item span {
  font-style: normal;
}

.do-dropdown__dropdown__item__name + .icon__bg-circle {
  opacity: 0;
}

.do-dropdown__dropdown__item:hover .do-dropdown__dropdown__item__name + .icon__bg-circle {
  opacity: 1;
}

.icon__checkmark {
  width: 30px;
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;
}

.icon__checkmark span {
  font-size: 14px;
}


.do-table {
  border: 1px solid #e2e8f0;
  border-width: 0 1px 1px 1px;
  padding: 8px;
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
}

.do-table thead {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  border-width: 1px 0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: 700;
  text-align: left;
  color: #8898aa;
  font-size: 10px;
}

.do-table thead th:first-child {
  cursor: pointer;
}

.do-table thead th,
.do-table tbody td {
  padding: 0.5rem 0.5rem;
}

.do-table thead th:first-child,
.do-table tbody td:first-child {
  width: 80px;
}

.do-table:not(.do-table__user-employments--import) thead th:nth-child(2),
.do-table:not(.do-table__user-employments--import) tbody td:nth-child(2),
.do-table.do-table__user-employments--import thead th:nth-child(1),
.do-table.do-table__user-employments--import tbody td:nth-child(1) {
  width: 300px;
}

.do-table tbody tr:nth-child(2n),
.user-group:nth-child(2n) {
  background-color: #f9fafb;
}

.do-table tbody tr .icon__bg-circle {
  opacity: 0;
}

.do-table tbody tr:hover .icon__bg-circle {
  opacity: 1;
}

.do-table tbody {
  display: block;
  overflow-y: scroll;
  overscroll-behavior: contain;
}

.do-table thead,
.do-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}


.d-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem
}

.d-tag {
  display: flex;
  align-items: center;
  padding: 1px 5px;
  border-radius: 4px;
  color: #333;
  border: 1px solid #c8d6e2;
  background: #f6f9fc;
  font-size: 11px;
  font-weight: 500;
  transition: background-color .02s;
}

.d-tag:hover {
  box-shadow: 0 0 1px 2px rgba(70,138,215,.56863);
}

.d-tag.d-tag--inner {
  font-size: 9px;
  border-left: 1px solid #ccc;
  background: none;
  border-width: 0 0 0 1px;
  border-radius: 0;
  line-height: 10px;
  margin-left: 5px;
  font-weight: normal;
  color: #868686;
}

.d-tag:hover .d-tag.d-tag--inner {
  color: #222;
}

.do-table tbody tr:hover {
  cursor: pointer;
  background: aliceblue;
}

.do-table__toggle-all {
  color: #468ad7;
  font-weight: 700;
  text-transform: initial;
  user-select: none;
}

.do-table__toggle-all:hover {
  color: #3e4450;
}

.d-checkbox {
  position: relative;
  margin-left: 1rem;
  height: 12px;
  width: 12px;
  border: 1px solid var(--border-color);
  border-radius: 2px;
  padding: 2px;
}

.do-table.do-table__user-employments--import tr {
  background: transparent !important;
}

.do-table.do-table__user-employments--import tr:hover {
  background: aliceblue !important;
}

.d-checkbox.d-checkbox--active {
  background: var(--blue);
  border-color: var(--blue);
}

.d-checkbox:after, .d-checkbox:before {
  transform: rotate(40deg);
}

.d-checkbox.d-checkbox--active:before,
.d-checkbox.d-checkbox--active:after {
  background: #fff;
}

.d-checkbox:after {
  content: '';
  display: block;
  width: 2px;
  height: 8px;
  background: transparent;
  position: absolute;
  top: 1px;
  right: 3px;
}

.d-checkbox:before {
  content: '';
  display: block;
  width: 4px;
  height: 2px;
  background: transparent;
  position: absolute;
  bottom: 2px;
  right: 5px;
}

.do-table tbody tr td:first-child:hover .d-checkbox {
  box-shadow: 0 0 1px 2px #468ad791;
}

.do-table.do-table__user-employments:not(.do-table__user-employments--import) tr th:last-child,
.do-table.do-table__user-employments:not(.do-table__user-employments--import) tr td:last-child {
  width: 40px;
}

.do-pill--small {
  padding: 0 0.5rem;
  font-size: 10px;
  line-height: 16px;
  margin-left: 0.5rem;
}

.d-tag--inline {
  display: inline-flex;
}

.user-group {
  border-bottom: 1px solid #eee;
}

.td-organisation {
  opacity: 0.7;
  font-size: 11px;
}

.toggle-flex {
  display: flex;
  align-items: center;
}

.toggle-flex--disabled {
  opacity: 0.15;
  cursor: not-allowed;
  background: transparent !important;
}

</style>



// WEBPACK FOOTER //
// SalarySettingsUsers.vue?f188f3ec